<template>
<div>
<wiz-layout
  v-model='location'
  :steps='steps'
  :initial-step='step'
  @close='exitWizard'
  @cancel='exitWizard' />

  <!-- <pre v-text="location.place.place_id" /> -->
</div>
</template>
<script>
import WizLayout from '@/components/wizards/WizLayout.vue'
import AddressPicker from '@/components/pickers/AddressPicker.vue'
// import Decision from '@/components/actions/wizards/Decision.vue'
import SuccessScreen from '@/components/wizards/screens/SuccessScreen.vue'
export default {
  name: 'LocationWizard',
  components: { WizLayout },
  props: {
    spaceId: { required: true },
    space: { required: false },
    successSteps: { type: Array, default: () => { return [] } },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      req: {
        create: {
          resource: 'ag.spaces.addresses'
        },
        save: {
          resource: 'ag.spaces.addresses'
        }
      },
      location: {
        name: null,
        is_virtual: false,
        place: {}
      }
    }
  },
  methods: {
    createLocation () {
      this.req.create.data = this.payload
      this.req.create.kwargs = {spaceId: this.spaceId}
      this.$request('save', this.req.create)
    },
    saveLocation (data) {
      this.req.save.data = data
      this.req.save.kwargs = {spaceId: this.spaceId}
      this.req.save.resourceId = this.location.id
      this.$request('save', this.req.save)
    },
    baseLocation () {
      return {
        name: null,
        is_virtual: false,
        place: {}
      }
    },
    reset () {
      this.location = this.baseLocation()
      this.step = 0
    },
    exitWizard () {
      this.$emit('cancel')
      this.reset()
    }
  },
  watch: {
    createRequestStatus () {
      if (this.createRequestStatus === 201) {
        this.step++
        this.location = this.req.create.result
        this.init()
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.step++
      }
    },
    touch () {
      this.reset()
    }
  },
  computed: {
    createRequestStatus () {
      return this.req.create.status
    },
    saveRequestStatus () {
      return this.req.save.status
    },
    place () {
      return this.getObjectPath(this.obj, 'place.geometry.location', null)
    },
    lat () {
      if (this.place && this.place.lat) {
        return this.place.lat()
      }
      return null
    },
    lng () {
      if (this.place && this.place.lng) {
        return this.place.lng()
      }
      return null
    },
    payload () {
      let pl = this.location
      pl['service'] = this.spaceId
      return pl
    },
    steps () {
      let vm = this
      return [
        {
          id: 'name',
          title: 'What is the name of this location?',
          attrs: {
            label: 'Name',
            persistentHint: true,
            box: true,
            hint: 'e.g.: Melrose Arch Virgin Active, ABC Welness center, Jessie Jones Bio - Lonehill  etc.'
          },
          back: { visible: true, disabled: true },
          next: { visible: true, disabled: true },
          nextText: 'Create',
          isValid (step, obj) {
            return (obj && obj.name && obj.name.length > 1)
          },
          onNext: () => {
            vm.createLocation()
          },
          events: {}
        },
        {
          id: 'is_virtual',
          title: 'What type of location is this?',
          attrs: {
            label: 'Type of location',
            items: [
              {
                value: false,
                text: 'Physical address'
              },
              {
                value: true,
                text: 'Virtual/Online'
              }
            ]
          },
          default: false,
          vcomponent: 'vradiogroup',
          back: { visible: true, disabled: true },
          next: { visible: true, disabled: true },
          nextText: 'Next',
          isValid () { return true },
          onNext: (step, obj) => {
            vm.saveLocation({is_virtual: obj.is_virtual})
          },
          events: {}
        },
        {
          id: 'place',
          title: 'Add address information',
          component: AddressPicker,
          attrs: {
            class: 'ma-5',
            withSummary: true
          },
          back: { visible: true, disabled: true },
          next: { visible: true, disabled: true },
          nextText: 'Next',
          isValid () {
            return (vm.location && vm.location.place && vm.location.place.place_id)
          },
          onNext: (step, obj) => {
            let data = {
              place_id: obj.place.place_id,
              place_data: obj.place,
              latitude: vm.lat,
              longitude: vm.lng
            }
            vm.saveLocation(data)
          },
          events: {}
        },
        {
          id: 'success',
          title: 'Success!',
          component: SuccessScreen,
          attrs: {
            actions: vm.successSteps
          },
          back: { visible: true, disabled: true },
          next: { visible: true, disabled: true },
          nextText: 'Next',
          isValid () {
            return (vm.location && vm.location.place && vm.location.place.place_id)
          },
          events: {}
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?adc3d7c4